import React, { useState } from 'react';
import { FLAG_BASE } from '../config';

type PhotoEndorsement = {
  id: string;
  type: 'photo';
  photo: string;
  caption: string;
  text: string;
};

type FlagsEndorsement = {
  id: string;
  type: 'flags';
  flags: string[];
  caption: string;
  text: string;
};

export type Endorsement = PhotoEndorsement | FlagsEndorsement;

export function EndorsementCard({ data, style }: { data: Endorsement; style?: React.CSSProperties }) {
  const [photoErr, setPhotoErr] = useState(false);

  return (
    <article className="endorsement-card" style={style}>
      {data.type === 'photo' && !photoErr ? (
        <div className="endorsement-card__photo-wrap">
          <img
            src={data.photo}
            alt=""
            loading="lazy"
            decoding="async"
            onError={() => setPhotoErr(true)}
            className="endorsement-card__photo"
          />
        </div>
      ) : data.type === 'flags' ? (
        <div className="endorsement-card__flags">
          {data.flags.map((cc) => (
            <img
              key={cc}
              src={`${FLAG_BASE}FLAG_${cc}.png`}
              alt={cc}
              className="endorsement-card__flag"
              loading="lazy"
              decoding="async"
              onError={(e) => {
                (e.target as HTMLImageElement).style.display = 'none';
              }}
            />
          ))}
        </div>
      ) : null}
      <div className="endorsement-card__body">
        <div className="endorsement-card__caption">{data.caption}</div>
        <p className="endorsement-card__text">{data.text}</p>
      </div>
    </article>
  );
}
